import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const getCurrencyRates = async () => {
  const res = await axios.get(apiRoutes.CURRENCY_RATES);
  return res.data;
};
